export const initialColors = {
  deep: '244, 219, 187',
  light: '252, 250, 243',
  main: '248, 242, 222',
  point: '140, 180, 160',
};
